import { getState } from "services/queryClient";

import { schoolsKey } from "../../consts";

export const getSchools = () => {
  return (getState(schoolsKey) || []) as any[];
};
